export default __webpack_public_path__ + "static/media/flower_img_top_schedule_2.ea219bb5.png";